import React from 'react';
import ProjectCard from '../components/Cards/ProjectCard';
import { projects } from '../data/projects';

const Projects = () => {
    const styles = {
        container: {
            minHeight: '100vh',
            paddingTop: '10%',
            paddingBottom: '48px',
            marginLeft: '5%',
            marginRight: '5%',
            marginBottom: '20px',
        },

        title: {
            fontSize: '2.25rem',
            fontWeight: 'bold',
            textAlign: 'center',
            marginBottom: '40px',
        },
        grid: {
            display: 'grid',
            gap: '32px',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        },
    };

    return (
        <div style={styles.container}>
            <h1 style={styles.title}>Proyectos del Curso</h1>
            <div style={styles.grid}>
                {projects.map((project) => (
                    <ProjectCard
                        key={project.id}
                        image={project.image}
                        title={project.title}
                        description={project.description}
                        link={project.link}
                    />
                ))}
            </div>
        </div>
    );
};

export default Projects;
